import React from "react";
import { buildEventRegistrationKpiDisplay } from "../shared/utils/eventRegistrationMetrics";
import "./EventRegistrationKpiCards.css";

/** One compact row: counts + horizontal bar + % (replaces stacked value + separate chart). */
function EventRegistrationKpiBarRow({ fractionText, pct, spillover }) {
  const safePct = pct != null && Number.isFinite(pct) ? Math.max(0, Math.min(100, Math.round(Number(pct)))) : null;
  const widthPct = safePct != null ? safePct : 0;
  return (
    <div className="event-qr-kpi-inline-row">
      <span className="event-qr-kpi-fraction">{fractionText}</span>
      <div className="event-qr-fill-bar" title={safePct != null ? `${safePct}%` : undefined}>
        <div
          className="event-qr-fill-bar__inner"
          style={{
            width: `${widthPct}%`,
            ...(spillover ? { opacity: 0.88 } : {}),
          }}
        />
      </div>
      <span className="event-qr-kpi-pct">{safePct != null ? `${safePct}%` : "—"}</span>
    </div>
  );
}

/**
 * Three-column Fill Rate / Turnout / Spillover cards — same UI as Event QR Check-In.
 * @param {{ metrics: object|null, className?: string, layout?: 'row'|'stack' }} props
 */
export default function EventRegistrationKpiCards({ metrics, className, layout = "row" }) {
  const kpi = buildEventRegistrationKpiDisplay(metrics);
  if (!kpi) return null;
  const rowClass = [
    "event-qr-kpi-row",
    layout === "stack" ? "event-qr-kpi-row--stack" : "event-qr-kpi-row--tabbed",
    className,
  ]
    .filter(Boolean)
    .join(" ");
  return (
    <div className={rowClass}>
      <div className="event-qr-kpi-card">
        <div className="event-qr-kpi-label">Fill Rate (Checked-In / Max Capacity)</div>
        <EventRegistrationKpiBarRow fractionText={kpi.fillFraction} pct={kpi.fillPct} />
      </div>
      <div className="event-qr-kpi-card">
        <div className="event-qr-kpi-label">Turnout (Checked-In / Registered)</div>
        <EventRegistrationKpiBarRow fractionText={kpi.turnFraction} pct={kpi.turnPct} />
      </div>
      <div className="event-qr-kpi-card">
        <div className="event-qr-kpi-label">Spillover (Waitlist / Max Capacity)</div>
        <EventRegistrationKpiBarRow fractionText={kpi.spillFraction} pct={kpi.spillPct} spillover />
      </div>
    </div>
  );
}
